// ---------------------------------------------------------------------------
// CandidateRailIsland — scrollable list of brainstorm candidate cards.
//
// Registered as `studio.brainstorm.candidate-rail` in the host IslandRegistry.
// Reads `candidates` + `expand` from the brainstorm slice via useStudioStore.
// ---------------------------------------------------------------------------

import { useStudioStore } from '@/store/studio-store'

interface CandidateRailIslandProps {
  activeId?: string
}

export function CandidateRailIsland({ activeId = '' }: CandidateRailIslandProps) {
  const candidates = useStudioStore((s) => s.brainstorm.candidates)
  const expand = useStudioStore((s) => s.brainstorm.expand)

  if (candidates.length === 0) return null

  return (
    <div className="flex flex-col gap-2 p-3">
      {candidates.map((c) => (
        <button
          key={c.id}
          type="button"
          data-testid={`brainstorm-card-${c.id}`}
          onClick={() => expand(c.id)}
          className={`border border-border rounded-md p-3 text-left hover:bg-foreground/5 transition-colors ${
            activeId === c.id ? 'ring-2 ring-primary border-primary' : ''
          }`}
        >
          <div className="text-xs text-muted-foreground mb-1">{c.id}</div>
          <div className="text-sm font-medium">{c.narrativeHeadline}</div>
          {c.dsCompatibility && (
            <div className="mt-1 text-[10px] uppercase tracking-wider text-muted-foreground">
              {c.dsCompatibility}
            </div>
          )}
        </button>
      ))}
    </div>
  )
}
